import React from 'react'
import { DiamondsFour, Gear, Question } from '@phosphor-icons/react'
import { IconButton } from '@shopflo/ui'
import { useRouter } from 'next/router'
import useNavigation from 'src/lib/hooks/useNavigation'
import { classNames } from 'src/lib/utils/helpers'
import BillingWidget from 'src/components/billing/BillingWidget'
import ClosedNavFooter from './nav-footer/CloseNavFooter'
import { useLocale } from 'src/lib/hooks/useLocal'
import { isPathActive } from 'src/lib/utils/path-matching'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'
import { useMerchant } from 'src/lib/contexts/MerchantContext'

const NavigationFooter = () => {
  const router = useRouter()
  const {
    getters: { sidebarOpen },
    actions: { resetAndRedirect }
  } = useNavigation()

  const { canAccess, isUserConfigured } = useUser()

  const { t } = useLocale()

  const {
    getters: { merchant }
  } = useMerchant()

  return (
    <div className='flex flex-col gap-2 mt-auto w-full '>
      <div className='border-t-1 border-gray-200 w-full'>
        {sidebarOpen ? (
          <div className='flex h-full w-full flex-col gap-2 p-2'>
            <button
              onClick={() => resetAndRedirect('/apps-integrations')}
              className={classNames(
                'relative flex h-[28px] w-full min-w-0 items-center justify-center overflow-hidden rounded-md px-1 py-1 hover:bg-black/5 disabled:cursor-not-allowed disabled:opacity-50',
                isPathActive(router.pathname, '/apps-integrations')
                  ? 'bg-white shadow-[0_0_0_0.5px_rgba(54,65,83,0.06),0_0.5px_1px_0_rgba(54,65,83,0.20)]'
                  : ''
              )}
              id='apps-store'
              disabled={!canAccess(permissionType.TAB_APP_STORE, 0) || !isUserConfigured}
            >
              <div className='grid w-[28px] place-content-center items-center justify-center text-lg'>
                <DiamondsFour size={18} className='text-zinc-600' />
              </div>
              <span className='flex min-w-0 flex-1 items-center overflow-hidden whitespace-nowrap px-1 text-text-sm-medium'>
                {t('apps_integrations')}
              </span>
            </button>

            <div className='flex items-center justify-between '>
              <div>
                <BillingWidget />
              </div>

              <div className='flex items-center gap-1'>
                <div onClick={() => resetAndRedirect('/settings')} id='settings'>
                  <IconButton
                    variant='ghost'
                    size='sm'
                    IconComponent={Gear}
                    tooltip={{ text: t('settings'), side: 'top', sideOffset: 1 }}
                    className={classNames(
                      'bg-gray-100 hover:bg-gray-200',
                      isPathActive(router.pathname, '/settings') ? 'bg-white' : ''
                    )}
                    disabled={!canAccess(permissionType.TAB_SETTINGS, 0) || !isUserConfigured}
                  />
                </div>
                <div onClick={() => resetAndRedirect('/support')} id='support'>
                  <IconButton
                    variant='ghost'
                    size='sm'
                    IconComponent={Question}
                    tooltip={{ text: t('support'), side: 'top', sideOffset: 1 }}
                    className={classNames(
                      'bg-gray-100 hover:bg-gray-200',
                      isPathActive(router.pathname, '/support', true) ? 'bg-white' : ''
                    )}
                    disabled={!canAccess(permissionType.TAB_SUPPORT, 0) || !isUserConfigured}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ClosedNavFooter />
        )}
      </div>
    </div>
  )
}

export default NavigationFooter
